'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = injectStaticAdContent;
/**
 * Function to insert static ad content into the DOM.
 * @param divContainer {HTMLDivElement}
 * @param adContent {string}
 */
function injectStaticAdContent(divContainer, adContent) {
  /* eslint-disable no-undef */
  var div = document.createElement('div');
  /* eslint-enable no-undef */
  div.innerHTML = adContent;
  // REV-1736: This is the current best way to make sure our styling is picked up
  div.children[0].style.display = 'inline-block';

  divContainer.appendChild(div);
  return div;
}